import type { Customer, GetCustomersResponse } from "./customer";
import type { GetProductsResponse, Product } from "./product";
import type { GetProductTokenResponse, ProductToken } from "./product-token";

export class TokenApiService {
  private readonly baseUrl: string;
  private readonly productCode: string;

  constructor({ baseUrl, productName }: { baseUrl: string; productName: string }) {
    this.baseUrl = baseUrl;
    this.productCode = productName;
  }

  public async getCustomers({ authToken }: { authToken: string }): Promise<Customer[]> {
    const response = await fetch(`${this.baseUrl}/v1/list/customers`, {
      method: "POST",
      headers: this.getHeaders(),
      body: JSON.stringify({
        userIdentityToken: authToken,
        product: this.productCode,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseData: GetCustomersResponse = await response.json();
    return responseData.data.customers;
  }

  public async getProducts({
    authToken,
    customerId,
  }: {
    authToken: string;
    customerId: number;
  }): Promise<Product[]> {
    const response = await fetch(`${this.baseUrl}/v1/list/products`, {
      method: "POST",
      headers: this.getHeaders(),
      body: JSON.stringify({
        userIdentityToken: authToken,
        customerId: String(customerId),
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseData: GetProductsResponse = await response.json();
    return responseData.data.products;
  }

  public async getProductToken({
    authToken,
    customerId,
  }: {
    authToken: string;
    customerId: number;
  }): Promise<ProductToken> {
    const response = await fetch(`${this.baseUrl}/v1/products/token`, {
      method: "POST",
      headers: this.getHeaders(),
      body: JSON.stringify({
        userIdentityToken: authToken,
        customerId: String(customerId),
        product: this.productCode,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseData: GetProductTokenResponse = await response.json();
    return responseData.data;
  }

  private getHeaders() {
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
  }
}
